'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function passwordIndicator(conditions) {
    return {
        id: 'password-indicator',
        component: 'magic-ui-password-indicator',
        isDataField: false,
        testId: 'step1-pw-indicator',
        dependency: 'password',
        properties: {
            conditions: conditions,
        },
    };
}

exports.passwordIndicator = passwordIndicator;
